import React from "react";

function BS4_Pagination() {
  return (
    <div>
      <h1>BS4_Pagination Component</h1>
      <p>This is the BS4_Pagination tutorial page content.</p>
    </div>
  );
}

export default BS4_Pagination;
